import { memo } from 'react';
import Image from 'next/image';
import styles from './Banner.module.scss';
import stylesFullPage from '../../FullPage.module.scss';
import bannerBackground from '../../assets/icons/Landing_Page_Top_Banner.png';

export const Banner = memo(({ agentTitle = '', fullName = '', personalPhotoUrl = '' }) => {
  return (
    <section className={styles.bannerContainer}>
      <div className={styles.banner}>
        <Image
          alt="Banner"
          src={bannerBackground}
          fill={true}
          priority={true}
          className={styles.bannerImage}
          quality={100}
        />
        <div className={styles.profilePhotoContainer}>
          {personalPhotoUrl && <img alt="Agent Photo" src={personalPhotoUrl} className={styles.profilePhoto} />}
        </div>
      </div>
      <div className={styles.agentInfoContainer}>
        <div className={stylesFullPage.container}>
          <div className={styles.agentInfoContainerCompanyInfo}>
            <div className={styles.agentInfoContainerCompanyInfoLeft}>
              <h2 className={styles.agentInfoContainerCompanyInfoHeader}>Who We Are</h2>
              <span className={styles.agentInfoContainerCompanyInfoBody}>
                American Republic Insurance Services&reg; was established to serve the needs of the retirement community
                through advice, service, and products. We represent top-rated, financially strong insurance companies
                with a variety of products. Our agents have access to top-tier solutions, enabling them to provide
                customized recommendations to meet each customer's unique needs.
              </span>
            </div>
            <div className={styles.agentInfoContainerCompanyInfoRight}>
              <h2 className={styles.agentInfoContainerCompanyInfoHeader}>What We Offer</h2>
              <span className={styles.agentInfoContainerCompanyInfoBody}>
                As a member of the American Republic Insurance Services&reg; team, you'll gain access to a wide range of
                top-quality products and trusted partner companies focused on retirement planning. Add our best-in-class
                support, comprehensive training, and cutting edge technology, and you'll have everything you need to
                grow your business rapidly and successfully.
              </span>
            </div>
          </div>
        </div>
        <div className={styles.agentInfoContainerCenter}>
          <h2 className={styles.agentName}>{fullName}</h2>
          <h3 className={styles.agentTitle}>American Republic Insurance Services&reg;</h3>
          <h3 className={styles.agentTitle}>{agentTitle}</h3>
        </div>
      </div>
    </section>
  );
});
